import styled from 'styled-components';
import BackgroundImage from '../../assets/logo-symbol.svg';
import { devices } from '../../styles/theme/devices';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: auto;
  overflow-x: hidden;
`;

export { Container };
